"use client";

import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { useRole } from "@/hooks/useRole";
import { usePathname } from "next/navigation";
import { AlertTriangle } from "lucide-react";

export function MaintenanceBanner() {
  const { isAdmin } = useRole();
  const settings = useQuery(api.maintenanceMode.getMaintenanceMode);
  const pathname = usePathname();

  // Don't show on dashboard routes
  if (pathname?.startsWith("/dashboard")) {
    return null;
  }

  // Only show to admins
  if (!isAdmin) {
    return null;
  }

  // Don't show if no maintenance mode is active
  if (!settings?.comingSoonEnabled && !settings?.maintenanceEnabled) {
    return null;
  }

  const isComingSoon = settings.comingSoonEnabled;
  const message = isComingSoon
    ? "Coming Soon mode is active"
    : "Maintenance mode is active";

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-8 bg-muted border-b border-border flex items-center justify-center px-4">
      <div className="flex items-center gap-2 text-xs">
        <AlertTriangle className="h-3.5 w-3.5" />
        <span className="font-medium">
          {message}
        </span>
      </div>
    </div>
  );
}
